export const ENVIRONMENT = {
  LOCAL: 'localDev',
  DEVELOPMENT: 'development',
};

export const FLOW_TYPES = {
  CONFIRMATION: 'CONFIRMATION',
  UNSUBSCRIBE: 'UNSUBSCRIBE',
};
